
  import { createRoot } from "react-dom/client";
  import App from "./app/App.tsx";
  import "./styles/index.css";
  import { installSessionFetch } from "./app/lib/session-fetch";

  // Ana API'ye giden tüm isteklere oturum belgesi (ENFORCE_SESSION için)
  installSessionFetch();

  // UTM parametrelerini ilk ziyarette yakala
  (function captureUtm() {
    try {
      const params = new URLSearchParams(window.location.search);
      const utmSource = params.get('utm_source');
      if (utmSource && !sessionStorage.getItem('utm_source')) {
        sessionStorage.setItem('utm_source', utmSource);
        sessionStorage.setItem('utm_medium', params.get('utm_medium') || '');
        sessionStorage.setItem('utm_campaign', params.get('utm_campaign') || '');
        sessionStorage.setItem('utm_content', params.get('utm_content') || '');
      }
    } catch {}
  })();

  createRoot(document.getElementById("root")!).render(<App />);
  